// 会員登録 - 業種
export const industryList = [
  { option: '建築主', value: '建築主' },
  { option: '設計', value: '設計' },
  { option: '施工', value: '施工' },
  { option: 'メーカー', value: 'メーカー' },
  { option: 'その他', value: 'その他' }
];

// 建材リスト ソート
export const productOrderList = [
  { option: 'CO2原単位の少ない順', value: 1 },
  { option: 'CO2削減量の大きい順', value: 2 },
  { option: '評価順', value: 3 },
  { option: 'マイリスト追加数順', value: 4 },
  { option: '新着順', value: 5 }
];

// 建材リスト 換算値
export const productMethodList = [
  { option: '%による換算値で表示', value: 1 },
  { option: 'メーカー算定値で表示', value: 3 },
  { option: '換算値+算定値で表示', value: 2 }
];

// 建材ステータス
export const productStatusList = [
  { disabled: false, option: '承認済', value: 1 },
  { disabled: false, option: '下書き', value: 2 },
  { disabled: false, option: '登録申請中', value: 3 },
  { disabled: false, option: '更新申請中', value: 4 },
  { disabled: false, option: '非承認', value: 9 }
];

// 建材 CO2算定根拠 種別（ラジオボタン）
export const co2CalcBasisOptions = [
  { label: '第三者認証', value: 1 },
  { label: '自社算定', value: 2 },
  { label: 'その他', value: 3 }
];

// 建材 事務局のおすすめフラグ
export const recommendFlgOptions = [
  { label: 'おすすめにする', value: 1 },
  { label: 'おすすめにしない', value: 0 }
];

// 退会理由
export const withdrawalReasonList = [
  { option: '登録されている建材が少ない', value: 1 },
  { option: '建材情報の信頼性に不安がある', value: 2 },
  { option: '使い方がわからない', value: 3 },
  { option: '利用する前のイメージと違った', value: 4 },
  { option: '他のサービスを利用しているため', value: 5 },
  { option: 'その他', value: 99 }
];

// お問合せ種別
export const radioOptions = [
  { label: '建材登録に関すること', value: 5 },
  { label: '事務処理に関すること', value: 1 },
  { label: 'システムに関すること', value: 2 },
  { label: '技術内容に関すること', value: 3 },
  { label: 'その他', value: 99 }
];

// 認定情報フラグ
export const certificationFlgOptions = [
  { label: '未取得', value: 0 },
  { label: '取得済', value: 1 }
];

// カーボンオフセットの利用（ラジオボタン）
export const carbonOffsetOptions = [
  { label: 'あり', value: 1 },
  { label: 'なし', value: 0 }
];
